<template>
  <div class="page home container-fluid px-5 home" v-if="page">
    <div v-if="page.introText" class="intro">
        <div v-if="page.introText.length" v-html="page.introText" class="intro-text text-xl"></div>
         <!-- Intro images -->
        <template
            v-if="page.introImages?.length"
        >
        <img
            v-for="(image, index) in page.introImages"
            :key="image.id"
            :src="image.url"
            :alt="image.title || ''"
            :width="image.width"
            :height="image.height"
            :class="{ active: index === activeIndex }"
            class="intro-image"
            loading="lazy"
        />
        </template>

    </div>

       <div class="newBlock row block" :class="[block.type]" v-for="block in page.contentBlocksNew" v-bind:key="block">
            <TextBlock
                v-if="block.type === 'textBlock'"
                :text="block.text"
                :alignment="block.alignment"
                :entryLink="block.entryLink"    
            />
            <NewsBlock
                v-else-if="block.type === 'newsBlock'"
                :heading="block.heading"
                :text="block.text"
                :alignment="block.alignment"
                :linkUrl="block.linkUrl"
            />
            <ProductInFocusBlock
                v-else-if="block.type === 'productInFocusBlock'"
                :heading="block.heading"
                :productTitle="block.productTitle"
                :text="block.text"
                :product="block.product"
            />
            <ProductsBlock
                v-else-if="block.type === 'productsBlock'"
                :heading="block.heading"
                :products="block.products"
            />
            <TeaserBlock
                v-else-if="block.type === 'teaserBlock'"
                :heading="block.heading"
                :text="block.text"
                :entryLink="block.entryLink"
                :image="block.image"
            />
            <TeaserXlBlock
                v-else-if="block.type === 'teaserXlBlock'"
                :heading="block.heading"
                :text="block.text"
                :entryLink="block.entryLink"
                :image="block.image"
            />
            <VideoBlock
                v-else-if="block.type === 'videoBlock'"
                :heading="block.heading"
                :alignment="block.alignment"
                :video="block.video"
                :previewImage="block.previewImage"
            />
            <ImagesBlock
                v-else-if="block.type === 'imagesBlock'"
                :heading="block.heading"
                :alignment="block.alignment"
                :images="block.images"
            />
            <SingleImageBlock
                v-else-if="block.type === 'singleImageBlock'"
                :image="block.image"
            />
            <GridBlock
                v-else-if="block.type === 'gridBlock'"
                :grid="block.grid"
                :border="block.border"
            />
        </div>
        <div class="row block" :class="[block.type]" v-for="block in page.contentBlocks" v-bind:key="block">
            <div :class="[block.className]" v-if="block.type == 'textBlock'" v-html="block.html"></div>
            <div :class="[block.className]" v-if="block.type == 'imageBlock'">
                <img :src="block.image" />
            </div>
        </div>
        <div class="productsRelated" v-if="page.productsRelated?.length">
            <div class="text-center text-base mb-3" v-html="page.titleProductsRelated"></div>
            <div class="row justify-content-center">
                <ProductPreview :product="product" v-for="product in page.productsRelated" v-bind:key="product" />
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { Page } from '@/http/Page';
import { Products } from '@/http/Products';
import ProductPreview from '@/components/shop/ProductPreviewComponent'

import TextBlock from '@/components/contentBlocksNew/TextBlock'
import NewsBlock from '@/components/contentBlocksNew/NewsBlock'
import ProductInFocusBlock from '@/components/contentBlocksNew/ProductInFocusBlock'
import ProductsBlock from '@/components/contentBlocksNew/ProductsBlock'
import TeaserBlock from '@/components/contentBlocksNew/TeaserBlock'
import TeaserXlBlock from '@/components/contentBlocksNew/TeaserXlBlock'
import VideoBlock from '@/components/contentBlocksNew/VideoBlock'
import ImagesBlock from '@/components/contentBlocksNew/ImagesBlock'
import SingleImageBlock from '@/components/contentBlocksNew/SingleImageBlock'
import GridBlock from '@/components/contentBlocksNew/GridBlock'

export default {
  name: 'Home',
  data(){
      return {
        page: null,
        activeIndex: 0,
        introInterval: null,
      }
  },
  components: {
    ProductPreview,
    TextBlock,
    NewsBlock,
    ProductInFocusBlock,
    ProductsBlock,
    TeaserBlock,
    TeaserXlBlock,
    VideoBlock,
    ImagesBlock,
    SingleImageBlock,
    GridBlock
  },
  mounted(){
    this.getPage();
      this.$store.dispatch('general/fetch');
  },
    beforeUnmount() {
    if (this.introInterval) {
      clearInterval(this.introInterval)
    }
  },
  methods: {
    async getPage() {
      const response = await Page.get('__home__')
      this.page = response.data

      // start rotation only after data exists
      if (this.page?.introImages?.length > 1) {
        this.startIntroRotation()
      }
    },

    startIntroRotation() {
      this.introInterval = setInterval(() => {
        this.activeIndex =
          (this.activeIndex + 1) % this.page.introImages.length
      }, 2000) // change speed here
    },
  },
}


</script>
